import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

const DesignEditorSecondaryControls = ({ className, children }) => {
  const classes = classNames({
    'design-editor-secondary-controls': true,
    [className]: !!className,
  });

  return <div className={classes}>{children}</div>;
};

DesignEditorSecondaryControls.propTypes = propTypes;

export default DesignEditorSecondaryControls;
